import React from 'react';
import { Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import { UploadOutlined } from '@ant-design/icons';
import get from 'lodash/get';
import cn from 'classnames';

import { InboxOutlinedIcon, PictureIcon, VideoIcon } from '@components/icons';
import TrashIcon from '@components/icons/TrashIcon';

const { Dragger } = Upload;

const headers = {
  Authorization: `Bearer ${window.localStorage.getItem('_token')}`,
};

const showUploadList = {
  showDownloadIcon: true,
  downloadIcon: <UploadOutlined width={14} height={14} />,
  showRemoveIcon: true,
  removeIcon: <TrashIcon width={14} height={14} />,
};

const iconRenderer = (file) => {
  if (file.type.includes('image')) {
    return <PictureIcon />;
  }

  return <VideoIcon />;
};

function DropZone({ className, onSuccess, ...rest }) {
  const { t } = useTranslation();
  const onChange = (e) => {
    const status = get(e, 'file.xhr.status', null);

    if (status >= 200 && status < 300) {
      onSuccess(e);
    }
  };

  return (
    <Dragger
      className={cn('drop-zone', className)}
      listType="picture"
      iconRender={iconRenderer}
      headers={headers}
      showUploadList={showUploadList}
      {...rest}
      onChange={onChange}
    >
      <p className="ant-upload-drag-icon">
        <InboxOutlinedIcon width={48} height={48} />
      </p>
      <p className="ant-upload-text">{t('move-files-or-click')}</p>
      <p className="ant-upload-hint">
        mp4, mov, jpg, png {t('no-more')} 200 {t('MB')}.
      </p>
    </Dragger>
  );
}

export default DropZone;
